import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const RefreshIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    {...props}
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M21.154 10.43a.536.536 0 0 0 .062-.166l.67-3.503a.877.877 0 0 0-.148-.666.921.921 0 0 0-1.263-.223.889.889 0 0 0-.375.573l-.33 1.752a8.154 8.154 0 0 0-3.205-3.17 8.363 8.363 0 0 0-8.738.433 8.108 8.108 0 0 0-2.862 3.473.86.86 0 0 0 .006.669.909.909 0 0 0 1.463.275.875.875 0 0 0 .192-.287 6.229 6.229 0 0 1 2.372-2.838 6.412 6.412 0 0 1 3.592-1.025 6.499 6.499 0 0 1 3.216.833 6.344 6.344 0 0 1 2.356 2.303l-1.473-.237a.921.921 0 0 0-.673.158.895.895 0 0 0-.363.578.869.869 0 0 0 .16.66.895.895 0 0 0 .59.356l3.795.622h.143a.844.844 0 0 0 .303-.053.296.296 0 0 0 .09-.052.7.7 0 0 0 .178-.096l.072-.088a.94.94 0 0 0 .125-.14.498.498 0 0 0 .044-.14ZM20.334 13.95a.912.912 0 0 0-.98.201.873.873 0 0 0-.19.29 6.232 6.232 0 0 1-2.368 2.807 6.421 6.421 0 0 1-3.567 1.021 6.508 6.508 0 0 1-3.219-.833 6.347 6.347 0 0 1-2.358-2.303l1.475.237h.143a.909.909 0 0 0 .653-.207.868.868 0 0 0 .101-1.239.902.902 0 0 0-.611-.306l-3.799-.605a.83.83 0 0 0-.295 0h-.071a1.04 1.04 0 0 0-.286.123.89.89 0 0 0-.161.158l-.08.087a.726.726 0 0 0-.063.167.38.38 0 0 0-.063.149l-.67 3.503a.859.859 0 0 0 .121.687.886.886 0 0 0 .594.382h.16a.905.905 0 0 0 .582-.198.873.873 0 0 0 .313-.52l.33-1.752a8.158 8.158 0 0 0 3.206 3.173 8.376 8.376 0 0 0 8.746-.43 8.11 8.11 0 0 0 2.867-3.47.86.86 0 0 0-.021-.663.886.886 0 0 0-.489-.459Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.9)" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default RefreshIcon;
